import script from "./ProductsIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsIcon.vue?vue&type=script&setup=true&lang=js"

import "./ProductsIcon.vue?vue&type=style&index=0&id=5590dc74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5590dc74"]])

export default __exports__